import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";
import {gsap} from "../../lib/gsap";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-burger");

        if (this.header) {
            this.toggleMobileNav();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeNav();
                } else {
                    this.openNav();
                }
            });
        }
    }

    static openNav() {
        document.body.classList.add("navs-open");
        Header.makeHeaderAsBannerTheme();

        GlobalVariables.lenis?.stop();
    }

    static closeNav() {
        document.body.classList.remove("navs-open");
        Header.restoreHeaderTheme();

        GlobalVariables.lenis?.start();
    }

    static resize() {
        this.closeNav();
    }
}